export default function Loading() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-white dark:bg-gray-900 z-50 animate-fadeIn">
      <div className="flex flex-col items-center space-y-4">
        {/* Spinner with gradient border */}
        <div className="h-16 w-16 border-4 border-t-blue-500 border-r-blue-400 border-b-blue-300 border-l-transparent rounded-full animate-spin"></div>

        {/* Loading text with pulse animation */}
        <p className="text-gray-700 dark:text-gray-200 text-lg font-medium animate-pulse">
          Loading...
        </p>
      </div>
    </div>
  );
}
